import { API, ConversationsAPI, ManagementAPI } from '@api';

export const store = {
  getAuth: () => {
    return API.TOKEN || ManagementAPI.TOKEN || ConversationsAPI.TOKEN;
  },
  setAuth: (token: string) => {
    API.TOKEN = token;
    ManagementAPI.TOKEN = token;
    ConversationsAPI.TOKEN = token;
  },
  setHeaders: (headers: Record<string, string>) => {
    API.HEADERS = headers;
    ManagementAPI.HEADERS = headers;
    ConversationsAPI.HEADERS = headers;
  },
  clearAuth: () => {
    API.TOKEN = '';
    ManagementAPI.TOKEN = '';
    ConversationsAPI.TOKEN = '';
  },
};
